export enum FilesPath {
  UserImages = 1,
  Achievements = 2,
  AnswerSheetTemplates = 3,
  VariantQuestionFiles = 4,
  Resources = 5,
  EmptyAnswerSheet = 6,
  FilledAnswerSheet = 7,
  UncheckedOmrAnswerSheet = 8,
  CheckedOmrAnswerSheet = 9,
  ExamBlankTemplates = 10,
  AnnouncementPhotos = 11,
  JudgeReviewFiles = 12,
  WinnersFiles = 13,
}
